// Services data — backend-ready. A future /api/services + /api/services/:slug can replace this.
import { IMAGES } from "./site";

export const SERVICES = [
  {
    id: "01",
    slug: "wsh-consultancy",
    icon: "ShieldCheck",
    title: "Workplace Safety & Health Consultancy",
    shortTitle: "WSH Consultancy",
    excerpt:
      "Compliance advisory, risk assessment, WSH management systems and personnel support to build safer, compliant workplaces.",
    image: IMAGES.wshInspection,
    heroTagline: "Workplace Safety & Health",
    intro:
      "SKY helps organisations understand their obligations under Singapore's workplace safety and health framework, close compliance gaps and build robust safety management systems that work in practice — not just on paper.",
    cta: "Discuss Your WSH Requirements",
    sections: [
      {
        title: "WSH Compliance Consultancy",
        items: [
          "WSH legislation and requirements review",
          "Compliance gap assessment",
          "WSH inspections",
          "Safety programme review",
          "Policies and procedures",
          "Regulatory compliance advisory",
          "Compliance action plans",
          "Ongoing advisory",
        ],
      },
      {
        title: "Risk Assessment & Risk Management",
        items: [
          "Risk Assessment",
          "Risk Management programme review",
          "Risk registers",
          "Control measures",
          "Safe Work Procedures",
          "Implementation monitoring",
          "Periodic reviews",
        ],
      },
      {
        title: "WSH Management Systems",
        items: [
          "WSH policies",
          "Objectives and programmes",
          "Roles and responsibilities",
          "Safety committees",
          "Inspection programmes",
          "Contractor safety",
          "Training and competency",
          "Incident reporting",
          "Emergency preparedness",
          "Corrective and preventive action",
          "Management review",
          "Continual improvement",
        ],
      },
      {
        title: "WSHO / WSH Coordinator Consultancy Support",
        items: [
          "Support for appointed WSH personnel",
          "Guidance on statutory WSH duties and documentation",
          "Assistance with inspections and workplace walkthroughs",
          "Development of safety programmes and records",
          "Advisory on incident reporting and follow-up",
          "Interim and ongoing WSH advisory support",
        ],
      },
    ],
  },
  {
    id: "02",
    slug: "fire-safety-consultancy",
    icon: "Flame",
    title: "Fire Safety Consultancy",
    shortTitle: "Fire Safety Consultancy",
    excerpt:
      "Fire safety compliance advisory, emergency response planning, evacuation exercises and fire safety manager support.",
    image: IMAGES.fireResponse,
    heroTagline: "Fire Safety & Emergency Preparedness",
    intro:
      "From fire safety compliance advisory to emergency response planning and drills, SKY helps organisations prevent fire incidents and prepare their people to respond effectively when it matters most.",
    cta: "Talk to a Fire Safety Consultant",
    sections: [
      {
        title: "Fire Safety Compliance Advisory",
        items: [
          "Fire safety inspections",
          "Fire hazard identification",
          "Review of fire safety provisions and housekeeping",
          "Fire safety procedures review",
          "Recommendations aligned with applicable requirements",
          "Fire safety action plans",
        ],
      },
      {
        title: "Emergency Response Plan (ERP)",
        items: [
          "Emergency Response Plan development",
          "ERP review and updating",
          "Emergency procedures and roles",
          "Emergency communication arrangements",
          "Coordination with relevant stakeholders",
        ],
      },
      {
        title: "Evacuation Drills & Table-Top Exercises",
        items: [
          "Evacuation exercise planning",
          "Drill coordination and facilitation",
          "Table-top scenario exercises",
          "Exercise evaluation and debrief",
          "Improvement recommendations",
        ],
      },
      {
        title: "Fire Safety Manager / FSM Support",
        items: [
          "Support for fire safety management duties",
          "Fire safety documentation and records",
          "Assistance with fire safety programmes",
          "Guidance on emergency preparedness",
        ],
      },
      {
        title: "Company Emergency Response Team / CERT Consultancy",
        items: [
          "CERT structure and roles advisory",
          "Emergency response capability review",
          "CERT readiness support",
          "Awareness and preparedness guidance",
        ],
      },
      {
        title: "Fire Investigation & Advisory",
        items: [
          "Fire incident advisory",
          "Contributing factor review",
          "Preventive recommendations",
          "Support for follow-up actions",
        ],
      },
    ],
  },
  {
    id: "03",
    slug: "wsh-training",
    icon: "GraduationCap",
    title: "WSH Training",
    shortTitle: "WSH Training",
    excerpt:
      "Practical workplace safety and health training across awareness, risk management, inspections and safety leadership.",
    image: IMAGES.classroom,
    heroTagline: "Workplace Safety & Health Training",
    intro:
      "SKY delivers practical, engaging workplace safety and health training designed to build competent people who can identify hazards, manage risks and contribute to a positive safety culture.",
    cta: "Enquire About WSH Training",
    columns: [
      {
        title: "Training Areas",
        items: [
          "WSH Awareness",
          "Risk Assessment",
          "Risk Management",
          "Safe Work Procedures",
          "Workplace Inspections",
          "Incident Investigation",
          "Safety Leadership",
          "Safety Culture",
          "Contractor Safety",
          "Work-at-Height Safety",
          "Machinery Safety",
          "Lifting Operation Safety",
          "Hazard Identification",
          "Emergency Preparedness",
          "Workplace Fire Safety",
          "Safety Orientation",
          "Toolbox / Safety Briefings",
        ],
      },
      {
        title: "Training Formats",
        items: [
          "In-house",
          "Classroom",
          "Practical",
          "Site-based",
          "Awareness sessions",
          "Management briefings",
          "Supervisor programmes",
          "Customised programmes",
        ],
      },
    ],
  },
  {
    id: "04",
    slug: "fire-safety-training",
    icon: "Flame",
    title: "Fire Safety & Emergency Response Training",
    shortTitle: "Fire Safety Training",
    excerpt:
      "Hands-on fire safety and emergency response training — extinguisher use, evacuation, fire wardens and response teams.",
    image: IMAGES.extinguisher,
    heroTagline: "Fire Safety & Emergency Response Training",
    intro:
      "Practical, scenario-based fire safety and emergency response training that prepares your people to prevent fires and respond confidently and safely during an emergency.",
    cta: "Enquire About Training",
    columns: [
      {
        title: "Training Areas",
        items: [
          "Fire Safety Awareness",
          "Fire Prevention",
          "Fire Extinguisher Use",
          "Practical Fire-Fighting",
          "Emergency Evacuation",
          "Emergency Response Procedures",
          "Fire Warden Training",
          "CERT Awareness",
          "Emergency Response Team Training",
          "Table-Top Exercises",
          "Fire Emergency Drills",
          "Fire Safety Leadership",
          "Fire Risk Awareness",
        ],
      },
    ],
  },
  {
    id: "05",
    slug: "corporate-safety-programmes",
    icon: "Users",
    title: "Corporate Safety Programmes",
    shortTitle: "Corporate Safety Programmes",
    excerpt:
      "Customised, organisation-wide safety programmes that strengthen safety culture, leadership and engagement.",
    image: IMAGES.corporateProgramme,
    heroTagline: "Customised Programmes for Organisations",
    intro:
      "SKY designs customised corporate safety programmes adaptable to your operational risks — engaging leaders, supervisors, contractors and workers to build a stronger, more proactive safety culture.",
    cta: "Develop a Custom Safety Programme",
    columns: [
      {
        title: "Programmes We Develop",
        items: [
          "Safety Culture Programmes",
          "Safety Leadership",
          "Management Safety Briefings",
          "Supervisor Safety Programmes",
          "Contractor Safety Programmes",
          "Workplace Hazard Awareness Campaigns",
          "Safety Stand-Down Programmes",
          "Safety Days",
          "Emergency Preparedness Campaigns",
          "Fire Safety Awareness Campaigns",
          "Safety Induction Programmes",
        ],
      },
    ],
  },
  {
    id: "06",
    slug: "safety-performance-improvement",
    icon: "TrendingUp",
    title: "Safety Performance Improvement",
    shortTitle: "Safety Performance Improvement",
    excerpt:
      "Go beyond compliance with performance reviews, KPIs, trend analysis and continuous improvement programmes.",
    image: IMAGES.riskAssessment,
    heroTagline: "Beyond Compliance",
    intro:
      "SKY helps organisations move beyond basic compliance — using reviews, indicators and structured improvement programmes to raise safety performance and sustain it over time.",
    cta: "Improve Your Safety Performance",
    columns: [
      {
        title: "Performance Improvement Services",
        items: [
          "WSH Performance Reviews",
          "Safety KPI Development",
          "Safety Inspection Programmes",
          "Incident Trend Analysis",
          "Near-Miss Reporting",
          "Corrective Action Tracking",
          "Safety Culture Assessment",
          "Management Safety Reviews",
          "Safety Improvement Roadmaps",
          "Continuous Improvement Programmes",
        ],
      },
    ],
  },
];

export const getServiceBySlug = (slug) =>
  SERVICES.find((s) => s.slug === slug);
